import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const UxAuditsIcon = () => {
  return (
    <span className="ux-audits-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g id="back">
          <rect className="cls-4" x="2.32" y="4.63" width="43.35" height="43.37" />
        </g>
        <motion.g
          id="path_6"
          animate={{ opacity: [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0] }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <path
            className="cls-3"
            d="M36.39,38.67h-7.74c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h6.97v-8.49c0-.43.35-.77.77-.77s.77.35.77.77v9.27c0,.43-.35.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="path_5"
          animate={{ opacity: [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0] }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <path
            className="cls-3"
            d="M24,36.35c-.43,0-.77-.35-.77-.77v-9.27c0-.43.35-.77.77-.77s.77.35.77.77v9.27c0,.43-.35.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="path_4"
          animate={{ opacity: [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0] }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <path
            className="cls-3"
            d="M31.74,27.09h-7.74c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h7.74c.43,0,.77.35.77.77s-.35.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="path_3"
          animate={{ opacity: [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0] }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <path
            className="cls-3"
            d="M24,27.09c-.43,0-.77-.35-.77-.77v-9.27c0-.43.35-.77.77-.77s.77.35.77.77v9.27c0,.43-.35.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="path_2"
          animate={{ opacity: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0] }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeatDelay: 1,
            repeat: Infinity,
          }}
        >
          <path
            className="cls-3"
            d="M24,27.09h-7.74c-.43,0-.77-.35-.77-.77s.35-.77.77-.77h7.74c.43,0,.77.35.77.77s-.35.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="path_1"
          animate={{ opacity: [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0] }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <path
            className="cls-3"
            d="M11.61,24.77c-.43,0-.77-.35-.77-.77v-9.27c0-.43.35-.77.77-.77h7.74c.43,0,.77.35.77.77s-.35.77-.77.77h-6.97v8.49c0,.43-.35.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="shape_5"
          animate={{
            opacity: [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0],
            scale: [1, 1, 1, 1, 1.4, 0.8, 1, 1, 1, 1, 1],
          }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <path
            className="cls-1"
            d="M26.32,40.22h-4.65c-1.28,0-2.32-1.04-2.32-2.32h0c0-1.28,1.04-2.32,2.32-2.32h4.65c1.28,0,2.32,1.04,2.32,2.32h0c0,1.28-1.04,2.32-2.32,2.32Z"
          />
        </motion.g>
        <motion.g
          id="shape_4"
          animate={{
            opacity: [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0],
            scale: [1, 1, 1, 1, 1, 1.4, 0.8, 1, 1, 1, 1],
          }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeatDelay: 1,
            repeat: Infinity,
          }}
        >
          <rect className="cls-2" x="31.74" y="24" width="9.29" height="4.63" />
        </motion.g>
        <motion.g
          id="shape_3"
          animate={{ rotate: [0, 360] }}
          transition={{
            ease: "linear",
            times: [0, 1],
            duration: 2,
            repeat: Infinity,
          }}
        >
          <polygon
            className="cls-1"
            points="19.35 26.32 24 24 28.65 26.32 24 28.63 19.35 26.32"
          />
        </motion.g>
        <motion.g
          id="shape_2"
          animate={{
            opacity: [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0],
            scale: [1, 1, 1.4, 0.8, 1, 1, 1, 1, 1, 1, 1],
          }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1
          }}
        >
          <rect className="cls-2" x="6.97" y="24" width="9.29" height="4.63" />
        </motion.g>
        <motion.g
          id="shape_1"
          animate={{
            opacity: [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0],
            scale: [1, 1, 1, 1.4, 0.8, 1, 1, 1, 1, 1, 1],
          }}
          transition={{
            ease: "easeOut",
            times: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <path
            className="cls-1"
            d="M26.32,17.05h-4.65c-1.28,0-2.32-1.04-2.32-2.32h0c0-1.28,1.04-2.32,2.32-2.32h4.65c1.28,0,2.32,1.04,2.32,2.32h0c0,1.28-1.04,2.32-2.32,2.32Z"
          />
        </motion.g>
        <g id="top">
          <path
            className="cls-1"
            d="M48,3.09c0,.85-.69,1.54-1.55,1.54H1.55c-.86,0-1.55-.69-1.55-1.54v-1.54C0,.69.69,0,1.55,0h44.9c.86,0,1.55.69,1.55,1.54v1.54Z"
          />
        </g>
      </svg>
    </span>
  )
}

export default UxAuditsIcon
